import * as React from 'react';
/**
 *
 * Original name: person
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3704%3A547
 *
 */
export const PersonSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { d: "M78 57h-4.131C77.188 53.047 79 47.265 79 40c0-14.4-7.1-23-19-23s-19 8.6-19 23c0 7.265 1.812 13.047 5.131 17H42a23.026 23.026 0 0 0-23 23v19h82V80a23.027 23.027 0 0 0-23-23ZM47 40c0-7.755 2.255-17 13-17 10.745 0 13 9.245 13 17 0 7.755-2.255 17-13 17-10.745 0-13-9.245-13-17Zm48 53H25V80a17.02 17.02 0 0 1 17-17h36a17.02 17.02 0 0 1 17 17v13Z", fill: "currentColor" })));
